import {customAxiosBE} from "../config";
import axios from "axios";
import {parsePaginationParams} from "../../utils/other";

export async function getAllRateAPI(payload) {
    const parsedParams = parsePaginationParams(payload)
    return customAxiosBE.get(`/rate?${parsedParams}`)
}
export async function getRateByIdAPI(id) {
    return customAxiosBE.get(`/rate/${id}`)
}
export async function getMonthlyPricesRateByIdAPI(data) {
    const { stationId1,stationId2 ,operatorId} = data
    return customAxiosBE.get(`/rate/monthly-prices?stationId1=${stationId1}&stationId2=${stationId2}&operatorId=${operatorId}`)
}

export async function getRateByStationsAndRateCardId(data){
    return customAxiosBE.post(`/rate/search?size=99999999`, data)
}
export async function findBySubOperator(data){
    return customAxiosBE.post(`/rate/findBySubOperator`, data)
}

export function findRatesForStations(stationIds, rateCardId) {
    return customAxiosBE.post("/rate/batch/findByStationIds", { stationIds, rateCardId });
}

export async function insertRateAPI(data) {
    return customAxiosBE.post(`/rate`,data)
}

export async function insertExceptionRateAPI(data) {
    return customAxiosBE.post(`/rate/saveOrUpdate`,data)
}
export async function updateRateAPI(data) {
    return customAxiosBE.put(`/rate`,data)
}

export async function deleteRateAPI(id) {
    return customAxiosBE.delete(`/rate/${id}`);
}
export async function getRatesByRateCardIdAPI(id) {
    return customAxiosBE.get(`/rate/byRateCardId/${id}`);
}

export async function insertCloneAPI(data) {
    return customAxiosBE.post(`/rate/clone`,data);
}

export const searchRateAPI = async (data, cancelToken) => {
    let response
    const {status, startStation, endStation, ticketType, station2Id, station1Id, rateCardId, operatorId} = data
    const parsedParams = parsePaginationParams(data)
    await customAxiosBE
        .post(`/rate/search?${parsedParams}`, {
            status: status,
            startStation: startStation,
            endStation: endStation,
            ticketTypeId: ticketType,
            station2Id: station2Id,
            station1Id: station1Id,
            rateCardId: rateCardId,
            operatorId: operatorId,
        }, {
            cancelToken
        })
        .then((r) => {
            response = r.data
        })
        .catch(error => {
            if (axios.isCancel(error)) {
                console.error('Request canceled', error.message);
            } else {
                // handle error response
            }
        });
    return response
}




